

/**
 * Converts a string to a 2-decimal-place string.
 * @example "123.456" => "123.46"
 */
export function stringToPointString(value) {
  const num = Number(value);
  return isNaN(num) ? '' : num.toFixed(2);
}

/**
 * Converts a string to a number with up to 2 decimals.
 * @example "123.456" => 123.46
 */
export function stringToPointNumber(value) {
  console.log(value)
  // const num = Number(value);
  // return isNaN(num) ? null : parseFloat(num.toFixed(2));
}

/**
 * Converts a number to a 2-decimal-place string.
 * @example 123.456 => "123.46"
 */
export function numberToPointString(value) {
  return typeof value === 'number' && !isNaN(value)
    ? value.toFixed(2)
    : '';
}

/**
 * Converts a number to a number with 2-decimal precision.
 * @example 123.456 => 123.46
 */
export function numberToPointNumber(value) {
  return typeof value === 'number' && !isNaN(value)
    ? parseFloat(value.toFixed(2))
    : null;
}
